import { el, setAttr, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';
import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import NavigableList from 'generics/components/navigable-list/native';

import databasesMenuIconString from 'assets/images/databases-menu-icon.svg?raw';

import directoryIconString from 'assets/images/directory-icon.svg?raw';

import productsMenuIconString from 'assets/images/products-menu-icon.svg?raw';

import expandRightIndicatorIconString from 'assets/images/right-arrow-icon-white-background.svg?raw';

import calendarMenuIconString from 'assets/images/calendar-menu-icon.svg?raw';

import './index.scss';

const databasesMenuIcon = stringToSVG(databasesMenuIconString);
const directoryIcon = stringToSVG(directoryIconString);
const productsMenuIcon = stringToSVG(productsMenuIconString);
const expandRightIndicatorIcon = stringToSVG(expandRightIndicatorIconString);
const calendarMenuIcon = stringToSVG(calendarMenuIconString);

setAttr(productsMenuIcon, { class: 'products-menu-icon' });

setAttr(databasesMenuIcon, {
  class: 'editor-action-button-icon data-collection-icon'
});

setAttr(directoryIcon, {
  class: 'editor-action-button-icon'
});

class ExpandableEditorActionButton {

  constructor(configuration) {

    this.configuration = configuration;
    this.optionsList = null;
    this.dynamicContentContainer = el('div.dynamic-content-container');

    this.labelDisplay = null;
    this.descriptionDisplay = null;

    this.el = el('.editor-action-button-main', {
      class: 'expandable',
      onmouseenter: this.handleMouseEnter.bind(this),
      onmouseleave: this.handleMouseLeave.bind(this)
    }, [
      el('.editor-action-button-icon-wrapper', [
        this.renderIcon()
      ]),
      el('.editor-action-button-data-wrapper', [
        this.labelDisplay = el('label.action-button-label.ellipsis', this.configuration.label),
        this.descriptionDisplay = el('p.action-button-description.ellipsis', this.configuration.description)
      ]),
      el('span.expand-right-indicator-icon-wrapper', [
        expandRightIndicatorIcon.cloneNode(true)
      ]),
      this.dynamicContentContainer
    ]);

  }

  unmountOptionsList() {

    unmount(this.dynamicContentContainer, this.optionsList);

  }

  handleMouseEnter() {

    this.expandOptions();

  }

  handleMouseLeave() {

    this.unmountOptionsList();

  }

  handleValueSelect(selectedOptions) {

    const selectedOption = selectedOptions[0];
    this.configuration.onClick(selectedOption);

    this.unmountOptionsList();

  }

  handleListClose() {

    this.unmountOptionsList();

  }

  expandOptions() {

    const options = {
      class: 'editor-action-button-options-list',
      entries: this.configuration.optionsGetter(),
      selectedEntries: [],
      onSelect: this.handleValueSelect.bind(this),
      onClose: this.handleListClose.bind(this),
      scrollAnchorElement: this.input
    };

    this.optionsList = new NavigableList(options);

    mount(this.dynamicContentContainer, this.optionsList);

    const element = this.optionsList.el.el;
    const anchorElement = this.el;
    const viewportElement = void 0;
    const verticalOffset = 0;
    const horizontalOffset = 0;
    const startSide = 'right';
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  renderIcon() {

    if (this.configuration.iconName === 'data-collection-icon') {
      return databasesMenuIcon.cloneNode(true);
    } else if (this.configuration.iconName === 'directory-icon') {
      return directoryIcon.cloneNode(true);
    } else if (this.configuration.iconName === 'product-icon') {
      return productsMenuIcon.cloneNode(true);
    } else if (this.configuration.iconName === 'calendar-icon') {
      return calendarMenuIcon.cloneNode(true);
    }

  }

  update(configuration) {

    this.configuration = configuration;
    this.labelDisplay.textContent = configuration.label;
    this.descriptionDisplay.textContent = configuration.description;

  }

}

export default ExpandableEditorActionButton;